// extracted by mini-css-extract-plugin
module.exports = {"author":"BlogAuthor_author__zbr3S","avatar":"BlogAuthor_avatar__kFmMD","info":"BlogAuthor_info__addz3","name":"BlogAuthor_name__uVsuJ","role":"BlogAuthor_role__8dkuN"};